import { useEffect, useState } from "react";

export default function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-foreground-950 text-background-50 flex items-center justify-center transition-all duration-300 hover:bg-primary-600 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}